import React, { memo, Fragment } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

const SKELETON_STYLES = {
  'height-22px': { height: '22px' },
  'height-40px': { height: '40px' },
  'width-80pct': { width: '80%' },
  'width-63px': { width: '63px' },
  'width-130px': { width: '130px' },
  'width-50pct': { width: '50%' },
};

export const FiltersSkeleton = memo(() => {
  return (
    <div className="usurp-filters p-1">
      <Skeleton
        className="d-block mb-1 rounded-6"
        style={{ ...SKELETON_STYLES['height-22px'], ...SKELETON_STYLES['width-80pct'] }}
      />
      <Skeleton
        className="d-block mb-1 rounded-6"
        style={{ ...SKELETON_STYLES['height-22px'], ...SKELETON_STYLES['width-63px'] }}
      />
      <div className="d-flex">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="rounded-16 mb-0_5 me-0_5"
            style={{ ...SKELETON_STYLES['height-22px'], ...SKELETON_STYLES['width-63px'] }}
          />
        ))}
      </div>
      <hr className="my-1" />
      <Skeleton
        className="d-block mb-1 rounded-6"
        style={{ ...SKELETON_STYLES['height-22px'], ...SKELETON_STYLES['width-50pct'] }}
      />
      <Skeleton
        className="d-block mb-1 rounded-6"
        style={{ ...SKELETON_STYLES['height-40px'], ...SKELETON_STYLES['width-130px'] }}
      />
      {Array.from({ length: 9 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <hr className="my-1" />
          <Skeleton
            className="d-block mb-1 rounded-6"
            style={{ ...SKELETON_STYLES['height-22px'], ...SKELETON_STYLES['width-80pct'] }}
          />
        </Fragment>
      ))}
    </div>
  );
});
